<template>
  <div>
    <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
      <template v-slot:item="props">
        <tr>
          <td
            v-for="(header, index) in headers"
            :key="index"
            :class="all(props.index) ? 'red lighten-1' : propRequired(header.value,props.index)"
          >
            <span>{{ props.item[header.value] }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      default: () => [],
      type: Array
    },
    properties: {
      default: () => [],
      type: Array
    }
  },
  data: () => ({
    headers: [
      {
        text: "Code",
        value: "code",
        sortable: false
      },
      {
        text: "Description",
        value: "desc",
        sortable: false
      }
    ]
  }),
  computed: {},
  methods: {
    propRequired(prop, index) {
      var result = this.properties.filter(item => {
        return (
          item.property.toLowerCase() == prop.toLowerCase() &&
          item.index == index &&
          item.mode == "OVERSEAS"
        );
      });

      if (result.length > 0) return "red lighten-1";
      else return "";
    },
    all(index) {
      var result = this.properties.filter(item => {
        return (
          item.property == "ALL" && item.mode == "OVERSEAS" && item.index == index
          //item.mode == "PAYLOC" && item.index == index
        );
      });
      if (result.length > 0) return true;
      else false;
    }
  }
};
</script>